import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-draft-tpr',
  standalone: false,
  templateUrl: './draft-tpr.component.html',
  styleUrl: './draft-tpr.component.scss'
})
export class DraftTprComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() id: any
  @Output() generatePDFEmitter = new EventEmitter<any>();
  commentForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() isEditable: boolean = false
  @Input() stepDetails: any;
  @Input() schemeType: any;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  rfpdata: any;
  uploadedFileName: string = '';
  file: File;
  private subscriptions = new Subscription();
  userID: any;

  constructor(private fb: FormBuilder, private messageService: MessageService, private api: ApiService, private route: ActivatedRoute) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required],
    });
     const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
    });
    this.getRfpDetails();

  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if ( this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
      editorReady = false;
  rebuildEditor() {
  this.editorReady = false; // destroy
  setTimeout(() => {
    this.init = this.getTinyInit(); // refresh config
    this.editorReady = true; // recreate editor
  }, 0);
}
getTinyInit(): EditorComponent['init'] {
  return {
    readonly: this.isEditorDisabled
  };
}
  goToNextStep() {
    this.stepCompleted.emit();
  }

  getRfpDetails(): void {
    let apiUrl = `/tdf/draft-tpr/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;

    // Call API
    const sub = this.api.getAPI(apiUrl).subscribe((res: any) => {
      this.rfpdata = res[0];
      this.uploadedUrl = this.rfpdata?.mom || this.rfpdata?.file || null;
      this.commentForm.patchValue({
        comment: this.rfpdata?.paragraph || this.rfpdata?.comment || ''
      });
    });
    this.subscriptions.add(sub);
  }

  onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }

  onSubmit(): void {
    const formData = new FormData();
    formData.append('proposal_step', this.step.id);
    formData.append('comment', this.commentForm.get('comment')?.value || '');

    if (this.file) {
      formData.append('file', this.file);
    }
    const baseUrl = `/tdf/draft-tpr/`;

    if (this.rfpdata?.id) {
      const sub = this.api.putAPI(`${baseUrl}${this.rfpdata.id}/`, formData).subscribe((res: any) => {
        this.uploadedFileName = null
        this.fileUpload.clear();
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'TPR updated successfully'
        });
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI(baseUrl, formData).subscribe((res: any) => {
        this.uploadedFileName = null
        this.fileUpload.clear();
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'TPR uploaded successfully'
        });
      });
    }
  }


  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
      { key: "Proposal Name", value: this.payload.proposal_name },
      { key: "TPR", value: this.commentForm.get('comment')?.value },
    ]
  }
    this.generatePDFEmitter.emit(payload);
  }

  getFileName(url: string): string {
  const fileName = url.split('/').pop() || 'Unknown File';
  return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
}
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    this.uploadedUrl = null;
    fileUpload.clear();
  }

}
